import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bruvtyx6ew: FaireBrandEntity = {
  token: "b_bruvtyx6ew",
  type: "brand",
  name: "Simpl Bars",
  avatarUrl:
    "https://cdn.faire.com/fastly/45de15055ba6a32d17f8bee17bebf1dc938c148994e47dfc80626610cc5441e5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a11e3b2e0bc4f333b3ac118832da9372aea72c2d58b8b926b28640d2625d6548.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/45de15055ba6a32d17f8bee17bebf1dc938c148994e47dfc80626610cc5441e5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a11e3b2e0bc4f333b3ac118832da9372aea72c2d58b8b926b28640d2625d6548.jpeg",
  location: "Goleta, CA, USA",
  minimumOrderDollars: 40,
  rating: 4.9,
  reviewCount: 32,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a mother-daughter company dedicated to simplifying haircare while reducing toxins and plastic waste. Frustrated with expensive, toxic products that didn’t work, we created salon-quality solid shampoo and conditioner bars using only natural, nourishing ingredients. Our handmade bars, crafted in small batches in Santa Barbara, California, are scented with essential oils and free from unnecessary packaging. We also offer zero-waste accessories to help retailers provide sustainable solutions. If you'd like to try our products before purchasing, message us for a free sample—we’re confident you’ll love them! And if you're ready to stock our products, please ask us for our Faire Direct link or find it on our Instagram bio! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:27.970Z",
    importedBy: "entity-db-cli",
  },
};
